export const stripPortalDomain = (url: string): string => {
  return url.startsWith('https://portal.estercare.com') ? url.replace('https://portal.estercare.com', '') : url
}

export const isInternalLink = (url: string): boolean => {
  return Boolean(url.startsWith('/') && !url.startsWith('//'))
}
